import _slicedToArray from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { __awaiter } from "tslib";
import { deepEquals, optionsFromArguments } from "../../core/util/Defaults";
import { readOnly } from "../../core/util/Interface";
import { isDefined } from "../../core/util/TypeCheck";
import { Signal } from "../../signal/Signal";
import { Source } from "../Source";
import { generateWaveform } from "./OscillatorInterface";
import { ToneOscillatorNode } from "./ToneOscillatorNode";
import { assertRange } from "../../core/util/Debug";
import { clamp } from "../../core/util/Math";
/**
 * Oscillator supports a number of features including
 * phase rotation, multiple oscillator types (see Oscillator.type),
 * and Transport syncing (see Oscillator.syncFrequency).
 *
 * @example
 * // make and start a 440hz sine tone
 * const osc = new Tone.Oscillator(440, "sine").toDestination().start();
 * @category Source
 */

export var Oscillator = /*#__PURE__*/function (_Source) {
  _inherits(Oscillator, _Source);

  var _super = _createSuper(Oscillator);

  function Oscillator() {
    var _this;

    _classCallCheck(this, Oscillator);

    _this = _super.call(this, optionsFromArguments(Oscillator.getDefaults(), arguments, ["frequency", "type"]));
    _this.name = "Oscillator";
    /**
     * the main oscillator
     */

    _this._oscillator = null;
    var options = optionsFromArguments(Oscillator.getDefaults(), arguments, ["frequency", "type"]);
    _this.frequency = new Signal({
      context: _this.context,
      units: "frequency",
      value: options.frequency
    });
    readOnly(_assertThisInitialized(_this), "frequency");
    _this.detune = new Signal({
      context: _this.context,
      units: "cents",
      value: options.detune
    });
    readOnly(_assertThisInitialized(_this), "detune");
    _this._partials = options.partials;
    _this._partialCount = options.partialCount;
    _this._type = options.type;

    if (options.partialCount && options.type !== "custom") {
      _this._type = _this.baseType + options.partialCount.toString();
    }

    _this.phase = options.phase;
    return _this;
  }

  _createClass(Oscillator, [{
    key: "_start",
    value:
    /**
     * start the oscillator
     */
    function _start(time) {
      var _this2 = this;

      var computedTime = this.toSeconds(time); // new oscillator with previous values

      var oscillator = new ToneOscillatorNode({
        context: this.context,
        onended: function onended() {
          return _this2.onstop(_this2);
        }
      });
      this._oscillator = oscillator;

      if (this._wave) {
        this._oscillator.setPeriodicWave(this._wave);
      } else {
        this._oscillator.type = this._type;
      } // connect the control signal to the oscillator frequency & detune


      this._oscillator.connect(this.output);

      this.frequency.connect(this._oscillator.frequency);
      this.detune.connect(this._oscillator.detune); // start the oscillator

      this._oscillator.start(computedTime);
    }
    /**
     * stop the oscillator
     */

  }, {
    key: "_stop",
    value: function _stop(time) {
      var computedTime = this.toSeconds(time);

      if (this._oscillator) {
        this._oscillator.stop(computedTime);
      }
    }
    /**
     * Restart the oscillator. Does not stop the oscillator, but instead
     * just cancels any scheduled 'stop' from being invoked.
     */

  }, {
    key: "_restart",
    value: function _restart(time) {
      var computedTime = this.toSeconds(time);
      this.log("restart", computedTime);

      if (this._oscillator) {
        this._oscillator.cancelStop();
      }

      this._state.cancel(computedTime);

      return this;
    }
    /**
     * Sync the signal to the Transport's bpm. Any changes to the transports bpm,
     * will also affect the oscillators frequency.
     * @example
     * const osc = new Tone.Oscillator().toDestination().start();
     * osc.frequency.value = 440;
     * // the ratio between the bpm and the frequency will be maintained
     * osc.syncFrequency();
     * // double the tempo
     * Tone.Transport.bpm.value *= 2;
     * // the frequency of the oscillator is doubled to 880
     */

  }, {
    key: "syncFrequency",
    value: function syncFrequency() {
      this.context.transport.syncSignal(this.frequency);
      return this;
    }
    /**
     * Unsync the oscillator's frequency from the Transport.
     * See Oscillator.syncFrequency
     */

  }, {
    key: "unsyncFrequency",
    value: function unsyncFrequency() {
      this.context.transport.unsyncSignal(this.frequency);
      return this;
    }
    /**
     * Get a cached periodic wave. Avoids having to recompute
     * the oscillator values when they have already been computed
     * with the same values.
     */

  }, {
    key: "_getCachedPeriodicWave",
    value: function _getCachedPeriodicWave() {
      var _this3 = this;

      if (this._type === "custom") {
        var oscProps = Oscillator._periodicWaveCache.find(function (description) {
          return description.phase === _this3._phase && deepEquals(description.partials, _this3._partials);
        });

        return oscProps;
      } else {
        var _oscProps = Oscillator._periodicWaveCache.find(function (description) {
          return description.type === _this3._type && description.phase === _this3._phase;
        });

        this._partialCount = _oscProps ? _oscProps.partialCount : this._partialCount;
        return _oscProps;
      }
    }
  }, {
    key: "type",
    get: function get() {
      return this._type;
    },
    set: function set(type) {
      this._type = type;
      var isBasicType = ["sine", "square", "sawtooth", "triangle"].indexOf(type) !== -1;

      if (this._phase === 0 && isBasicType) {
        this._wave = undefined;
        this._partialCount = 0; // just go with the basic approach

        if (this._oscillator !== null) {
          // already tested that it's a basic type
          this._oscillator.type = type;
        }
      } else {
        // first check if the value is cached
        var cache = this._getCachedPeriodicWave();

        if (isDefined(cache)) {
          var partials = cache.partials,
              wave = cache.wave;
          this._wave = wave;
          this._partials = partials;

          if (this._oscillator !== null) {
            this._oscillator.setPeriodicWave(this._wave);
          }
        } else {
          var _this$_getRealImagina = this._getRealImaginary(type, this._phase),
              _this$_getRealImagina2 = _slicedToArray(_this$_getRealImagina, 2),
              real = _this$_getRealImagina2[0],
              imag = _this$_getRealImagina2[1];

          var periodicWave = this.context.createPeriodicWave(real, imag);
          this._wave = periodicWave;

          if (this._oscillator !== null) {
            this._oscillator.setPeriodicWave(this._wave);
          } // set the cache


          Oscillator._periodicWaveCache.push({
            imag: imag,
            partialCount: this._partialCount,
            partials: this._partials,
            phase: this._phase,
            real: real,
            type: this._type,
            wave: this._wave
          });

          if (Oscillator._periodicWaveCache.length > 100) {
            Oscillator._periodicWaveCache.shift();
          }
        }
      }
    }
  }, {
    key: "baseType",
    get: function get() {
      return this._type.replace(this.partialCount.toString(), "");
    },
    set: function set(baseType) {
      if (this.partialCount && this._type !== "custom" && baseType !== "custom") {
        this.type = baseType + this.partialCount;
      } else {
        this.type = baseType;
      }
    }
  }, {
    key: "partialCount",
    get: function get() {
      return this._partialCount;
    },
    set: function set(p) {
      assertRange(p, 0);
      var type = this._type;
      var partial = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(this._type);

      if (partial) {
        type = partial[1];
      }

      if (this._type !== "custom") {
        if (p === 0) {
          this.type = type;
        } else {
          this.type = type + p.toString();
        }
      } else {
        // extend or shorten the partials array
        var fullPartials = new Float32Array(p); // copy over the partials array

        this._partials.forEach(function (v, i) {
          return fullPartials[i] = v;
        });

        this._partials = Array.from(fullPartials);
        this.type = this._type;
      }
    }
    /**
     * Returns the real and imaginary components based
     * on the oscillator type.
     * @returns [real: Float32Array, imaginary: Float32Array]
     */

  }, {
    key: "_getRealImaginary",
    value: function _getRealImaginary(type, phase) {
      var fftSize = 4096;
      var periodicWaveSize = fftSize / 2;
      var real = new Float32Array(periodicWaveSize);
      var imag = new Float32Array(periodicWaveSize);
      var partialCount = 1;

      if (type === "custom") {
        partialCount = this._partials.length + 1;
        this._partialCount = this._partials.length;
        periodicWaveSize = partialCount; // if the partial count is 0, don't bother doing any computation

        if (this._partials.length === 0) {
          return [real, imag];
        }
      } else {
        var partial = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(type);

        if (partial) {
          partialCount = parseInt(partial[2], 10) + 1;
          this._partialCount = parseInt(partial[2], 10);
          type = partial[1];
          partialCount = Math.max(partialCount, 2);
          periodicWaveSize = partialCount;
        } else {
          this._partialCount = 0;
        }

        this._partials = [];
      }

      for (var n = 1; n < periodicWaveSize; ++n) {
        var piFactor = 2 / (n * Math.PI);
        var b = void 0;

        switch (type) {
          case "sine":
            b = n <= partialCount ? 1 : 0;
            this._partials[n - 1] = b;
            break;

          case "square":
            b = n & 1 ? 2 * piFactor : 0;
            this._partials[n - 1] = b;
            break;

          case "sawtooth":
            b = piFactor * (n & 1 ? 1 : -1);
            this._partials[n - 1] = b;
            break;

          case "triangle":
            if (n & 1) {
              b = 2 * (piFactor * piFactor) * (n - 1 >> 1 & 1 ? -1 : 1);
            } else {
              b = 0;
            }

            this._partials[n - 1] = b;
            break;

          case "custom":
            b = this._partials[n - 1];
            break;

          default:
            throw new TypeError("Oscillator: invalid type: " + type);
        }

        if (b !== 0) {
          real[n] = -b * Math.sin(phase * n);
          imag[n] = b * Math.cos(phase * n);
        } else {
          real[n] = 0;
          imag[n] = 0;
        }
      }

      return [real, imag];
    }
    /**
     * Compute the inverse FFT for a given phase.
     */

  }, {
    key: "_inverseFFT",
    value: function _inverseFFT(real, imag, phase) {
      var sum = 0;
      var len = real.length;

      for (var i = 0; i < len; i++) {
        sum += real[i] * Math.cos(i * phase) + imag[i] * Math.sin(i * phase);
      }

      return sum;
    }
    /**
     * Returns the initial value of the oscillator when stopped.
     * E.g. a "sine" oscillator with phase = 90 would return an initial value of -1.
     */

  }, {
    key: "getInitialValue",
    value: function getInitialValue() {
      var _this$_getRealImagina3 = this._getRealImaginary(this._type, 0),
          _this$_getRealImagina4 = _slicedToArray(_this$_getRealImagina3, 2),
          real = _this$_getRealImagina4[0],
          imag = _this$_getRealImagina4[1];

      var maxValue = 0;
      var twoPi = Math.PI * 2;
      var testPositions = 32; // check for peaks in 16 places

      for (var i = 0; i < testPositions; i++) {
        maxValue = Math.max(this._inverseFFT(real, imag, i / testPositions * twoPi), maxValue);
      }

      return clamp(-this._inverseFFT(real, imag, this._phase) / maxValue, -1, 1);
    }
  }, {
    key: "partials",
    get: function get() {
      return this._partials.slice(0, this.partialCount);
    },
    set: function set(partials) {
      this._partials = partials;
      this._partialCount = this._partials.length;

      if (partials.length) {
        this.type = "custom";
      }
    }
  }, {
    key: "phase",
    get: function get() {
      return this._phase * (180 / Math.PI);
    },
    set: function set(phase) {
      this._phase = phase * Math.PI / 180; // reset the type

      this.type = this._type;
    }
  }, {
    key: "asArray",
    value: function asArray() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1024;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", generateWaveform(this, length));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Oscillator.prototype), "dispose", this).call(this);

      if (this._oscillator !== null) {
        this._oscillator.dispose();
      }

      this._wave = undefined;
      this.frequency.dispose();
      this.detune.dispose();
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Source.getDefaults(), {
        detune: 0,
        frequency: 440,
        partialCount: 0,
        partials: [],
        phase: 0,
        type: "sine"
      });
    }
  }]);

  return Oscillator;
}(Source);
/**
 * Cache the periodic waves to avoid having to redo computations
 */

Oscillator._periodicWaveCache = [];